module.exports = __webpack_public_path__ + "static/img/menage3.db40795a.jpg";